import {useStore} from "react-redux";
import {Profile} from "../store";
import {createContext, ReactNode, useContext} from "react";

export type UserContextType = Profile | null

export const UserContext = createContext<UserContextType>(null);

export const UserContextProvider = ({children}: { children?: ReactNode }) => {

    const store = useStore();

    const profile = store.getState().get("core")?.get("profile") as Profile | null;

    if (!profile) {
        return <>{children}</>;
    }

    if ("loading" in profile) {
        if (profile.loading)
            return <>{children}</>;
    }

    if (!profile.loggedIn)
        return <>{children}</>;

    return (
        <UserContext.Provider value={profile}>
            {children}
        </UserContext.Provider>
    );
};

export function useToken() {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useToken must be used within a UserContextProvider");
    }

    return context.auth.token;
}

export function useAccountKey() {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useToken must be used within a UserContextProvider");
    }

    return context.account.account_key;
}

export function useProfile(): Profile {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useProfile must be used within a UserContextProvider");
    }

    return context;
}

export function useIsSuper(): boolean {
    const context = useContext(UserContext);
    if (!context) {
        return false;
    }

    return context.claims.roles.includes("SUPER");
}

export function useIsRoot(): boolean {
    const context = useContext(UserContext);
    if (!context) {
        return false;
    }

    return context.claims.roles.includes("ROOT");
}
